/* eslint key-spacing: 'off', comma-spacing: 'off' */
import current from '@/scripts/current'
import navigation from '@/scripts/logisticRegression/navigation'

export default {
  type: '/logisticRegression',
  getNextPage: function (currentStep) {
    var step = navigation.getStep(currentStep);
    var stepIndex = navigation.stepIndex[step];
    var thePage = navigation.getPage(stepIndex, stepIndex + 1);
    return thePage;
  },
  getPreviousPage: function (currentStep) {
    var step = navigation.getStep(currentStep);
    var stepIndex = navigation.stepIndex[step];
    return navigation.getPage(stepIndex, stepIndex - 1);
  },
  getPage: function (stepIndex, nextStepIndex) {
    return nextStepIndex > navigation.keys.length || nextStepIndex < 0 ? navigation.page[navigation.keys[stepIndex]]
      : navigation.page[navigation.keys[nextStepIndex]];
  },
  getStep: function (currentStep) {
    return currentStep === undefined || currentStep === null ? current.selectionModel.currentStep : currentStep;
  },
  initialize: function () {
    navigation.keys = Object.keys(navigation.page);
    navigation.keys.forEach((k, i) => {
        navigation.stepIndex[k] = i;
        navigation.step[k] = k;
    });
  },
  keys: null,
  stepIndex: {
    //root: 0,
    //years: 1,
    //...
  },
  page: {
    root: '/',
    years: '/logisticRegression/selectYear',
    location: '/logisticRegression/selectLocation',
    selectDependentVariable: '/logisticRegression/selectDependentVariable',
    selectIndependentVariables: '/logisticRegression/selectIndependentVariables',
    setReference: '/logisticRegression/setReference',
    viewreport: '/logisticRegression/viewReport'
  },
  titles: {
    root: '/',
    years: 'Logistic Regression Years',
    location: 'Location',
    selectDependentVariable: 'Dependent',
    selectIndependentVariables: 'Independent',
    setReference: 'Reference',
    viewreport: 'Report'
  },
//   navItems: {
//     root: '/',
//     years: '/logisticRegression/selectYear',
//     location: '/logisticRegression/selectLocation',
//     selectDependentVariable: '/logisticRegression/selectDependentVariable',
//     selectIndependentVariables: '/logisticRegression/selectIndependentVariables',
//     setReference: '/logisticRegression/setReference',
//     viewreport: '/logisticRegression/viewReport'
//   },
  routeNames: {
    root: '/',
    years: 'logisticRegressionSelectYear',
    location: 'logisticRegressionSelectLocation',
    selectDependentVariable: 'logisticRegressionSelectDependentVariable',
    selectIndependentVariables: 'logisticRegressionSelectIndependentVariables',
    setReference: 'logisticRegressionSetReference',
    viewreport: 'logisticRegressionViewReport'
  },
  step: {
    //years: 'years',
    //location: 'location',
    //...
  }
}
